import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckGreen } from '@assets/images/check-green.svg';
import './style.scss';
import { Discount } from '@src/global/types/types';
import { addFreeTrialDates } from '@src/global/utils/date';

type FreeTrialTermsProps = {
  discount?: Discount;
};

const FreeTrialTerms = ({ discount }: FreeTrialTermsProps) => {
  const { t } = useTranslation();
  const amount = discount?.freeTrialDuration?.amount;
  const units = discount?.freeTrialDuration?.units;
  const date = addFreeTrialDates(new Date(), amount, units);

  return (
    <section className="free-trial-terms" data-testid="free-trial-terms">
      <div className="free-trial-terms__content">
        <p className="free-trial-terms__content-title">
          {t('checkout.summary.terms&conditions.title')}
        </p>
        <ul className="free-trial-terms__content-list">
          <li className="free-trial-terms__content-item">
            <div>
              <CheckGreen />
            </div>
            <span>{t('checkout.summary.terms&conditions.billingStarts')}</span>
          </li>
          <li className="free-trial-terms__content-item">
            <div>
              <CheckGreen />
            </div>
            <span>
              {t('checkout.summary.terms&conditions.cancelBefore', { date })}
            </span>
          </li>
        </ul>
      </div>
    </section>
  );
};

export { FreeTrialTerms };
